import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";

const APP_URL = import.meta.env.VITE_APP_URL ?? "https://app.coach-os.eu";

const Success = () => (
  <div className="min-h-screen flex flex-col items-center justify-center text-center p-8 bg-background">
    <div className="w-16 h-16 rounded-full bg-accent/10 flex items-center justify-center mb-6">
      <Check className="w-8 h-8 text-accent" />
    </div>
    <h1 className="text-3xl font-bold mb-3 text-foreground">Bienvenue sur CoachOS !</h1>
    <p className="text-muted-foreground mb-8 max-w-md">
      Votre abonnement est activé. Créez votre compte pour commencer à coacher.
    </p>
    <Button asChild className="bg-accent text-accent-foreground hover:bg-accent/90">
      <a href={`${APP_URL}/signup`}>Créer mon compte</a>
    </Button>
  </div>
);

export default Success;
